import React, { useEffect, useState } from 'react';
import './unauth-header-mobile.styles.scss'

import { useSelector } from 'react-redux';
import UserIcon from '../layout-auth/user-icon/user-icon.component';
import UnuathUserDropdown from './unauth-user-dropdown.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import UnauthMenuDropdown from './unauth-menu-dropdown.component';
import { Link, useLocation } from 'react-router-dom';
import ImageContainer from '../SHARED/image-container/image-container.component';
import logo_long from '@/assets/logo_long.png';

const UnauthHeaderMobile = () => {
    
    const [ showUserDropdown, setShowUserDropdown ] = useState(false);
    const [ showMenuDropdown, setShowMenuDropdown ] = useState(false);
    const userProfile = useSelector(state => state.userData.userProfile);
    const location = useLocation();

    function toggleDropdown(e) {
        console.log(e);
        if (showUserDropdown) {
            setShowUserDropdown(false);
        } else if (e === 'user') {
            setShowUserDropdown(true);
        }
        if (showMenuDropdown) {
            setShowMenuDropdown(false);
        } else if (e === 'menu') {
            setShowMenuDropdown(true);
        }
    }

    return (
        <div className="unauth-mobile-header">
            <div className='header-grid'>
                <div className='left-col'>
                    <button
                        className='g-button text-only icon-button'
                        onClick={() => toggleDropdown('menu')}>
                        <FontAwesomeIcon icon={faBars} size='xl' />
                    </button>
                    <img src={logo_long} alt='Gamably Logo' className='logo' />
                </div>
                {
                    (userProfile)
                    ?
                    <button 
                        className='g-button text-only icon-button'
                        onClick={() => toggleDropdown('user')} >
                        <UserIcon 
                            className='clickable' 
                            profile={userProfile} 
                            reverse={true} 
                            planIcon={true} />
                    </button>
                    :
                    (location.pathname === '/')
                    ?
                    <Link to="/signin">
                        <button 
                            className='g-button small-btn primary'>
                            Sign In
                        </button>
                    </Link>
                    :
                    null
                }
            </div>
            <UnuathUserDropdown
                show={showUserDropdown} />
            <UnauthMenuDropdown 
                show={showMenuDropdown} />
        </div>
    );
};

export default UnauthHeaderMobile;